<template>
  <el-form
    size="mini"
    label-position="top"
    @submit.native.prevent="$emit('apply')"
    @keydown.native.enter.prevent="$emit('apply')"
  >
    <el-form-item class="m-0">
      <template #label>
        <slot
          name="label"
          :resource="resource"
          :filterable="filterable"
        >
          {{ filterable.label }}
        </slot>

        <slot
          name="operator"
          :resource="resource"
          :filterable="filterable"
        >
          <FilterOperator
            v-show="!isBooleanFieldType && advanced"
            :resource="resource"
            :filterable="filterable"
          />
        </slot>
      </template>

      <slot
        name="input"
        :resource="resource"
        :filterable="filterable"
      >
        <FilterInput
          :resource="resource"
          :filterable="filterable"
          @apply="$emit('apply')"
        />
      </slot>
    </el-form-item>
  </el-form>
</template>

<script>
import FilterOperator from '@/components/Filters/Simplified/Filter/Operator'
import FilterInput from '@/components/Filters/Simplified/Filter/Input'
import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN } from '@/plugins/sdk/fields'

export default {
  components: {
    FilterOperator,
    FilterInput
  },
  props: {
    resource: {
      type: [ Object, Function ],
      required: true
    },
    filterable: {
      type: Object,
      required: true
    },
    advanced: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    /**
     * Returns an instance of the resources field relative to the
     * filters active field.
     */
    resourceField () {
      let resource = this.resource
      let field

      if (typeof this.filterable.filter.field !== 'undefined') {
        this
          .filterable
          .filter
          .field
          .split('.')
          .map(f => {
            if (resource instanceof Resource) {
              field = resource.constructor.fields[f]
            } else if (resource.prototype instanceof Resource) {
              field = resource.fields[f]
            }

            resource = field._resource || resource
          })
      }

      return field
    },
    /**
     * Determines if the field type is boolean.
     */
    isBooleanFieldType () {
      return this.resourceField instanceof BOOLEAN
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  width: 100%;
}
</style>
